import { z } from 'zod';

export const SessionResponseSchema = z.object({
  lastUsedAt: z
    .date()
    .nullable()
    .transform((val) => (val ? val.toISOString() : null)),
  createdAt: z.date().transform((val) => val.toISOString()),
  deviceInfo: z.string().nullable(),
  expiresAt: z.date().transform((val) => val.toISOString()),
  id: z.string(),
  ipAddress: z.string().nullable(),
  isRevoked: z.boolean(),
  userAgent: z.string().nullable(),
});

export type ISessionResponseDto = z.infer<typeof SessionResponseSchema>;
